// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PE4yP","questions":"styles_questions__3ZGbp","footer":"styles_footer__5KZ8K"};